import type { Identifier, RaRecord } from "ra-core";

export interface ShipmentItem {
  description: string;
  details?: string;
  quantity: number;
  unit_price: number;
}

export type TradeType = "external" | "intercompany";

export const tradeTypeChoices = [
  { id: "external", name: "egi.trade_type.external" },
  { id: "intercompany", name: "egi.trade_type.intercompany" },
];

export type Shipment = {
  invoice_number: string;
  invoice_date: string;
  company_id: Identifier;
  contact_id?: Identifier | null;
  sales_id: Identifier;
  status: "active" | "void";
  // intercompany = parent/subsidiary trade, excluded from the owner's share
  trade_type: TradeType;
  items: ShipmentItem[];
  tax: number;
  total: number;
  notes?: string;
  created_at: string;
  // Electronic signature (see migration 20261022120000_shipment_signatures.sql)
  sign_token?: string | null;
  signed_at?: string | null;
  signer_name?: string | null;
  signer_ip?: string | null;
  signature_png?: string | null;
  signed_hash?: string | null;
} & Pick<RaRecord, "id">;

export const itemsSubtotal = (items: Partial<ShipmentItem>[] = []): number =>
  Math.round(
    items.reduce(
      (sum, i) => sum + Number(i?.quantity || 0) * Number(i?.unit_price || 0),
      0,
    ) * 100,
  ) / 100;

const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
export const formatUsd = (n: number): string => usd.format(n || 0);
